<script>import { getAttrs } from "../ctx.js";
export let asChild = false;
const attrs = getAttrs("head-cell");
</script>

{#if asChild}
	<slot {attrs} />
{:else}
	<th {...$$restProps} {...attrs}>
		<slot {attrs} />
	</th>
{/if}
